import React, { useState } from 'react'
import styles from './Dropdown.module.scss'
import Icon from '../icon/Icon'
import classNames from 'classnames'

const Dropdown = (props) => {
  const { options, initialValue, onChange, error } = props

  const [value, setValue] = useState(initialValue)

  const selectOptions = options.map((option, index) => (
    <option key={index} value={option.name}>
      {option.name}
    </option>
  ))

  const selectStyles = classNames(styles.select, { [styles.error]: error })

  const handleOnChange = (event) => {
    const targetValue = event.target.value;
    setValue(targetValue)
    onChange(targetValue)
  }

  return (
    <div className={styles.selectWrapper}>
      <span className={styles.iconWrapper}>
        <Icon name="caret-down-solid" size="small" appearance="light" />
      </span>
      <span className={styles.rule} />
      <select className={selectStyles} value={value} onChange={handleOnChange}>
        {selectOptions}
      </select>
    </div>
  )
}

Dropdown.defaultProps = {
  error: false,
  onChange: () => void 0
}

export default Dropdown
